var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm.required
      ? _c("span", { staticClass: "text-danger mx-1" }, [_vm._v("*")])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "checkbox"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.vModel,
              expression: "vModel",
            },
          ],
          staticClass: "form-control",
          attrs: {
            autocomplete: _vm.autocomplete,
            id: _vm.name,
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: !!_vm.disabled,
            readonly: _vm.readonly,
            maxlength: _vm.maxLength,
            minlength: _vm.minLength,
            type: "checkbox",
          },
          domProps: {
            checked: Array.isArray(_vm.vModel)
              ? _vm._i(_vm.vModel, null) > -1
              : _vm.vModel,
          },
          on: {
            keyup: _vm.onKeyUp,
            input: _vm.handleInput,
            blur: _vm.validateValue,
            change: function ($event) {
              var $$a = _vm.vModel,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.vModel = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.vModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.vModel = $$c
              }
            },
          },
        })
      : _vm.type === "radio"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.vModel,
              expression: "vModel",
            },
          ],
          staticClass: "form-control",
          attrs: {
            autocomplete: _vm.autocomplete,
            id: _vm.name,
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: !!_vm.disabled,
            readonly: _vm.readonly,
            maxlength: _vm.maxLength,
            minlength: _vm.minLength,
            type: "radio",
          },
          domProps: { checked: _vm._q(_vm.vModel, null) },
          on: {
            keyup: _vm.onKeyUp,
            input: _vm.handleInput,
            blur: _vm.validateValue,
            change: function ($event) {
              _vm.vModel = null
            },
          },
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.vModel,
              expression: "vModel",
            },
          ],
          staticClass: "form-control",
          attrs: {
            autocomplete: _vm.autocomplete,
            id: _vm.name,
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: !!_vm.disabled,
            readonly: _vm.readonly,
            maxlength: _vm.maxLength,
            minlength: _vm.minLength,
            type: _vm.type,
          },
          domProps: { value: _vm.vModel },
          on: {
            keyup: _vm.onKeyUp,
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.vModel = $event.target.value
              },
              _vm.handleInput,
            ],
            blur: _vm.validateValue,
          },
        }),
    _vm._v(" "),
    _vm.validationError || _vm.getErrorMessage
      ? _c("small", { staticClass: "form-text text-danger" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.validationError || _vm.getErrorMessage) +
              "\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }